import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import { requireAuthPages } from './requireAuthPages';
import { setCanonicalFromApi } from '../module/canonicalLink'; // ← آدرس دقیق فایل تابع شما

Vue.use(VueRouter);

export const router = new VueRouter({
    routes: routes,
    mode: 'history'
});

// کنترل صفحات نیازمند احراز هویت
router.beforeEach((to, from, next) => {
    var authRequired = false;
    for (var i = 0; i < requireAuthPages.length; i++) {
        if (to.path.startsWith(requireAuthPages[i])) {
            authRequired = true;
            break;
        }
    }

    if (authRequired) {
        var accessToken = localStorage.getItem('accessToken');
        if (accessToken == '' || accessToken == null)
            return next('/login?returnUrl=' + to.path);
    }

    next(true);
});

// بعد از هر روت، canonical را از API ست کن
router.afterEach((to) => {
    const encodedFullPath = encodeURIComponent(to.fullPath);
    console.log("Encoded path =>", encodedFullPath);
    setCanonicalFromApi(encodedFullPath);
});
